<template>
  <div class="cookie-settings-banner">
    <div class="wrapper" :style="{ width: `${width}px`, height: `${height}px` }">
      <div class="description-col">{{ $t('cookieSettingsBanner.description.text') }}</div>
      <div class="settings-col">
        <span class="settings-btn" @click="handleSettingsBtnClick">{{
          $t('cookieSettingsBanner.settings.text')
        }}</span>
      </div>
      <div class="accept-btn-col">
        <base-button
          :title="$t('cookieSettingsBanner.accept.btnText')"
          @buttonClicked="handleAcceptBtnClick"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from './BaseButton.vue';

export default {
  name: 'CookieSettingsBanner',
  props: {
    width: {
      type: Number,
      required: false,
      default: 800,
    },
    height: {
      type: Number,
      required: false,
      default: 100,
    },
  },
  components: {
    BaseButton,
  },
  methods: {
    handleAcceptBtnClick() {
      this.$cookies.set('cookie_status', 'all', 60 * 60 * 24 * 30);
      window['ga-disable-UA-152001488-1'] = false;
      setTimeout(() => {
        // eslint-disable-next-line no-restricted-globals
        location.reload();
      }, 500);
    },
    handleSettingsBtnClick() {
      this.$emit('settingsBtnClicked');
    },
  },
};
</script>

<style lang="scss" scoped>
.cookie-settings-banner {
  z-index: 999;
}
.wrapper {
  background: #fff;
  box-shadow: 0 10px 20px -10px rgba(105, 119, 135, 0.2), 0 20px 30px -10px rgba(56, 56, 56, 0.05);
  display: flex;
  align-items: center;
  border-radius: 25px;

  @media screen and (max-width: 991px) {
    width: 100% !important;
    flex-wrap: wrap;
    height: auto !important;
  }

  @media screen and (max-width: 575px) {
    justify-content: center;
  }
}

.description-col {
  max-width: 375px;
  font-size: 14px;
  line-height: 24px;
  margin: 0 30px 0 37px;

  @media screen and (max-width: 991px) {
    max-width: none;
    margin: 20px 30px;
  } 
}

.settings-col {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 26px;
  border: 1px solid #eae7e2;
  border-top: 0;
  border-bottom: 0;

  @media screen and (max-width: 991px) {
    margin-bottom: 20px;
    border: 0;
  }

  span {
    height: 100%;
    display: flex;
    align-items: center;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    cursor: pointer;
    padding: 0;
    transition: all 0.3s ease-in-out;

    &:hover {
      color: #246ac7;
    }
  }
}

.accept-btn-col {
  margin: 0 30px 0;
  flex: 1 0 auto;

  .base-button /deep/ button {
    display: block;
    width: 100%;
  }

  @media screen and (max-width: 991px) {
    height: 50px;
    margin-bottom: 20px;
  }
}
</style>
